import {useCallback, useMemo, useState} from "react";

import type {TestimonialItem} from "@/sections";
import type {KeenSliderInstance} from "keen-slider";
import type {KeenSliderOptions} from "keen-slider/react";

import {createSliderConfig} from "../slider-testimonials.config";

type UseSliderStateReturn = {
    currentIndex: number;
    sliderInstance: KeenSliderInstance | null;
    sliderConfig: KeenSliderOptions | undefined;
    handleSliderInit: (slider: KeenSliderInstance) => void;
};

export function useSliderState(testimonials: Array<TestimonialItem>): UseSliderStateReturn {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [sliderInstance, setSliderInstance] = useState<KeenSliderInstance | null>(null);

    const sliderConfig = useMemo(() => createSliderConfig(testimonials.length), [testimonials.length]);

    const handleSliderInit = useCallback((slider: KeenSliderInstance): void => {
        setSliderInstance(slider);

        const updateIndex = (instance: KeenSliderInstance): void => {
            const details = instance.track?.details;
            if (details) {
                setCurrentIndex(details.rel);
            }
        };

        slider.on("created", updateIndex);
        slider.on("slideChanged", updateIndex);
    }, []);

    return {
        currentIndex,
        sliderInstance,
        sliderConfig,
        handleSliderInit,
    };
}
